import { render, staticRenderFns } from "./alarmInfo.vue?vue&type=template&id=6d810adc&scoped=true"
import script from "./alarmInfo.vue?vue&type=script&lang=js"
export * from "./alarmInfo.vue?vue&type=script&lang=js"
import style0 from "./alarmInfo.vue?vue&type=style&index=0&id=6d810adc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d810adc",
  null
  
)

export default component.exports